<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>

          <CCardBody>
            <DeliveryOperations/>

<!--            <BTabs :active-tab.sync="active_tab" >-->
<!--              <BTab  :title="$t('deliveryOperation')">-->
<!--              </BTab>-->
<!--              <BTab  :title="$t('route')">-->
<!--                <InsertRoutes/>-->
<!--              </BTab>-->

<!--              <BTab :title="$t('cars')">-->
<!--                <InsertWheicle/>-->
<!--              </BTab>-->

<!--              <BTab :title="$t('driver')">-->
<!--                <DeliveryInserts/>-->
<!--              </BTab>-->

<!--            </BTabs>-->


          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import BTabs from "../../tabs/BTabs";
var items = [];
import DeliveryOperations from "./DeliveryOperations";
import InsertRoutes from "./InsertRoutes"
import InsertWheicle from "./InsertWheicle";
import DeliveryInserts from "./DeliveryInserts";
import BTab from "../../tabs/BTab";
export default {
  name: 'SaleSettingsComponent',
  components: {
    BTab,
    BTabs,
    DeliveryOperations,
    InsertRoutes,
    InsertWheicle,
    DeliveryInserts
  },
  data() {
    return {
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,

      active_tab:parseInt(localStorage.getItem("sale_setting_active_tab",0)),

    }
  }, mounted() {
    this.$root.root_validate_errors = [];

    // this.get_lists();

  }, watch: {

    'active_tab': function () {
      localStorage.setItem("sale_setting_active_tab",this.active_tab)
    }
  },
  methods: {

  }
}

</script>
